import { useGetFetch } from '../reactQuery';
import { PRODUCT_BANK_API } from '../../../constant/api_url';
import { ProductBankInputAuditLog } from '../../../types/productBankAuditLog.types';

export const useProductBankLogs = (id: number | string) =>
  useGetFetch<ProductBankInputAuditLog[]>(`${PRODUCT_BANK_API}/${id}/changes`, undefined, {
    enabled: !!id,
  });
